import React from 'react';
import PropTypes from 'prop-types';

import styles from 'styles/components/account/cancellationReason.scss';

const CancellationReason = ({ itemUniqueId, lineItem, cancellationReasons, onCancellationReasonChange }) => {
  const reasonId = `reason-${itemUniqueId}`;

  return (
    <div className={styles.cancellationReason}>
      <label htmlFor={reasonId}>Why are you cancelling this item?</label>
      <select
        id={reasonId}
        value={cancellationReasons[lineItem.id]}
        onChange={onCancellationReasonChange.bind(this, lineItem)}
        required>
        <option value="no-reason">Please select a reason</option>
        <option value="no-longer-want">No longer want the item</option>
        <option value="too-late">Item/Order will arrive too late</option>
        <option value="duplicate-order">Duplicate order</option>
        <option value="wrong-item">Wrong item ordered</option>
      </select>
    </div>
  );
};

CancellationReason.propTypes = {
  lineItem: PropTypes.object.isRequired,
  cancellationReasons: PropTypes.array.isRequired,
  onCancellationReasonChange: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired
};

export default CancellationReason;
